module.exports = {
      id: "follow-youtube-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#follow-youtube",
      toString: function () {
        return this.url;
      }
    }